import * as Models from '../misc/models';
import { AppService } from './app-service';

/**
 * Submit SSO email gate details to get the next action required
 */
export function submitSsoEmailGate(id: string, email: string, recaptchaResponse: string): Promise<Models.SsoEmailGateResult> {
    let body = JSON.stringify({ id, email, recaptchaResponse });
    return AppService.PostThenToObject<Models.SsoEmailGateResult>('openinvitation/emailgate', body, Models.SsoEmailGateResult);
}